import React, { useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { DepotoCore } from 'depoto-core'
import { Loader } from '../components'
import { useLogin } from '../hooks'

type Props = {
  core: DepotoCore
}

export const ExternalLogin: React.FC<Props> = ({ core }) => {
  const { handleExternalLogin } = useLogin()
  const navigate = useNavigate()
  const location = useLocation()
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    void (async () => {
      const ok = await handleExternalLogin(core, location.search)
      if (ok) {
        navigate('/dashboard')
      } else {
        navigate('/login')
      }
    })()
  }, [])

  return <Loader />
}
